import type {InvertSockets} from "#material/nodes/color/invert/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<InvertSockets>
type Previous = Omit<Current, "settings"> & {settings: MaterialNodeSettings<InvertSockets> & {disabled?: boolean}}

/** Muting a node is ui.disabled, which every renderer reads and the exchange format carries as internal.mute. */
export const dropDisabledNoRendererReads: Version<Previous, Current> = {
    toNextVersion: ({settings: {disabled, ...settings} = {}, ...parameters}) => ({...parameters, settings}),
}
